import { CardMedia, Stack, styled } from '@mui/material';
import type { HeaderProps } from './interfaces';
import type { Institution } from '@/models/catalog/course';

const InstitutionLogo = styled('img')(() => ({
  height: 70,
  width: 180,
}));

const BlurredFrame = styled('div')({
  position: 'relative',
  overflow: 'hidden',
  height: 100,
  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    filter: 'blur(20px)',
    transform: 'scale(1.1)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
});

const Institution = ({ institution }: { institution: Institution }) => {
  return (
    <Stack
      height={100}
      alignItems="center"
      justifyContent="center"
      sx={{ backgroundColor: institution.logo_background_color }}
    >
      {institution.logo_url && <InstitutionLogo src={institution.logo_url} alt={institution.name} />}
    </Stack>
  );
};

const Video = ({ image }: { image: HeaderProps['image'] }) => {
  const backgroundImageUrl = `url(${image?.src})`;

  return (
    <BlurredFrame
      style={{ '--bg': backgroundImageUrl } as React.CSSProperties}
      sx={{ '::before': { backgroundImage: 'var(--bg)' } }}
    >
      <CardMedia
        component="img"
        image={image?.src}
        alt={image?.alt ?? ''}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          position: 'relative',
          zIndex: 1,
        }}
      />
    </BlurredFrame>
  );
};

const Image = ({ image }: { image: HeaderProps['image'] }) => {
  return (
    <CardMedia
      component="img"
      image={image?.src}
      sx={{ width: '100%', height: 100, objectFit: 'cover' }}
      alt={image?.alt ?? ''}
    />
  );
};

export const Header = ({ institution, image }: HeaderProps) => {
  const renderByType = {
    video: <Video image={image} />,
    image: <Image image={image} />,
  };

  if (image) return renderByType[image?.type];

  if (institution?.name) return <Institution institution={institution} />;

  return null;
};
